var _g, _path, _g2, _g3, _path2, _g4, _path3, _g5, _g6, _path4, _g7, _path5, _g8, _g9, _path6, _g10, _path7, _g11, _g12, _g13, _path8, _g14, _path9, _g15, _g16, _g17, _path10, _g18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarSpinnerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 941,
    height: 391,
    viewBox: "0 0 941 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.426 245.916L109.769 259.198L96.4868 261.855L109.769 264.512L112.426 277.794L115.083 264.512L128.365 261.855L115.083 259.198L112.426 245.916Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.426 245.916L109.769 259.198L96.4868 261.855L109.769 264.512L112.426 277.794L115.083 264.512L128.365 261.855L115.083 259.198L112.426 245.916Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.152
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.152,
    filter: "url(#filter1_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.187 298.515L224.53 311.797L211.248 314.454L224.53 317.111L227.187 330.393L229.844 317.111L243.126 314.454L229.844 311.797L227.187 298.515Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.152,
    d: "M227.187 298.515L224.53 311.797L211.248 314.454L224.53 317.111L227.187 330.393L229.844 317.111L243.126 314.454L229.844 311.797L227.187 298.515Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M772.304 155.064L770.446 164.361L761.147 166.221L770.446 168.081L772.304 177.378L774.164 168.081L783.461 166.221L774.164 164.361L772.304 155.064Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M772.304 155.064L770.446 164.361L761.147 166.221L770.446 168.081L772.304 177.378L774.164 168.081L783.461 166.221L774.164 164.361L772.304 155.064Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.096 266.637L877.237 275.934L867.939 277.795L877.237 279.655L879.096 288.952L880.956 279.655L890.253 277.795L880.956 275.934L879.096 266.637Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M929.096 184.637L927.237 193.934L917.939 195.795L927.237 197.655L929.096 206.952L930.956 197.655L940.253 195.795L930.956 193.934L929.096 184.637Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.691
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.691,
    filter: "url(#filter4_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.766 330.394L701.907 339.691L692.609 341.551L701.907 343.411L703.766 352.708L705.626 343.411L714.923 341.551L705.626 339.691L703.766 330.394Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.691,
    d: "M703.766 330.394L701.907 339.691L692.609 341.551L701.907 343.411L703.766 352.708L705.626 343.411L714.923 341.551L705.626 339.691L703.766 330.394Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.167 96.0889L335.309 105.386L326.01 107.246L335.309 109.106L337.167 118.404L339.027 109.106L348.324 107.246L339.027 105.386L337.167 96.0889Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M337.167 96.0889L335.309 105.386L326.01 107.246L335.309 109.106L337.167 118.404L339.027 109.106L348.324 107.246L339.027 105.386L337.167 96.0889Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.923 38.7083L399.065 48.0055L389.766 49.8656L399.065 51.7257L400.923 61.023L402.783 51.7257L412.081 49.8656L402.783 48.0055L400.923 38.7083Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M400.923 38.7083L399.065 48.0055L389.766 49.8656L399.065 51.7257L400.923 61.023L402.783 51.7257L412.081 49.8656L402.783 48.0055L400.923 38.7083Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.14,
    filter: "url(#filter7_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.375 325.612L542.517 334.909L533.218 336.769L542.517 338.629L544.375 347.927L546.235 338.629L555.532 336.769L546.235 334.909L544.375 325.612Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M544.375 325.612L542.517 334.909L533.218 336.769L542.517 338.629L544.375 347.927L546.235 338.629L555.532 336.769L546.235 334.909L544.375 325.612Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.106 325.612L351.248 334.909L341.949 336.769L351.248 338.629L353.106 347.927L354.966 338.629L364.263 336.769L354.966 334.909L353.106 325.612Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M353.106 325.612L351.248 334.909L341.949 336.769L351.248 338.629L353.106 347.927L354.966 338.629L364.263 336.769L354.966 334.909L353.106 325.612Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.593 214.038L223.735 223.335L214.436 225.195L223.735 227.056L225.593 236.353L227.453 227.056L236.751 225.195L227.453 223.335L225.593 214.038Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.593 214.038L223.735 223.335L214.436 225.195L223.735 227.056L225.593 236.353L227.453 227.056L236.751 225.195L227.453 223.335L225.593 214.038Z",
    fill: "white"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.413
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.413,
    filter: "url(#filter10_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2634 102.464L48.4049 111.762L39.1061 113.622L48.4049 115.482L50.2634 124.779L52.1235 115.482L61.4208 113.622L52.1235 111.762L50.2634 102.464Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.413,
    d: "M50.2634 102.464L48.4049 111.762L39.1061 113.622L48.4049 115.482L50.2634 124.779L52.1235 115.482L61.4208 113.622L52.1235 111.762L50.2634 102.464Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter11_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.289 57.8351L303.961 64.4769L297.319 65.8046L303.961 67.1324L305.289 73.7742L306.616 67.1324L313.258 65.8046L306.616 64.4769L305.289 57.8351Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M305.289 57.8351L303.961 64.4769L297.319 65.8046L303.961 67.1324L305.289 73.7742L306.616 67.1324L313.258 65.8046L306.616 64.4769L305.289 57.8351Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.131 59.7131L606.804 66.355L600.162 67.6827L606.804 69.0104L608.131 75.6522L609.459 69.0104L616.101 67.6827L609.459 66.355L608.131 59.7131Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M608.131 59.7131L606.804 66.355L600.162 67.6827L606.804 69.0104L608.131 75.6522L609.459 69.0104L616.101 67.6827L609.459 66.355L608.131 59.7131Z",
    fill: "white"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.4 214.038L798.073 220.68L791.431 222.008L798.073 223.335L799.4 229.977L800.728 223.335L807.37 222.008L800.728 220.68L799.4 214.038Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M799.4 214.038L798.073 220.68L791.431 222.008L798.073 223.335L799.4 229.977L800.728 223.335L807.37 222.008L800.728 220.68L799.4 214.038Z",
    fill: "white"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter14_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M847.218 54.6473L845.89 61.2892L839.248 62.6169L845.89 63.9446L847.218 70.5864L848.545 63.9446L855.187 62.6169L848.545 61.2892L847.218 54.6473Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M847.218 54.6473L845.89 61.2892L839.248 62.6169L845.89 63.9446L847.218 70.5864L848.545 63.9446L855.187 62.6169L848.545 61.2892L847.218 54.6473Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter15_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.01 309.673L638.682 316.315L632.04 317.642L638.682 318.97L640.01 325.612L641.337 318.97L647.979 317.642L641.337 316.315L640.01 309.673Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M640.01 309.673L638.682 316.315L632.04 317.642L638.682 318.97L640.01 325.612L641.337 318.97L647.979 317.642L641.337 316.315L640.01 309.673Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.167 201.287L335.839 207.929L329.197 209.256L335.839 210.584L337.167 217.226L338.495 210.584L345.136 209.256L338.495 207.929L337.167 201.287Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M337.167 201.287L335.839 207.929L329.197 209.256L335.839 210.584L337.167 217.226L338.495 210.584L345.136 209.256L338.495 207.929L337.167 201.287Z",
    fill: "white"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter17_d_111_65811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.106 265.043L351.778 271.685L345.136 273.013L351.778 274.34L353.106 280.982L354.434 274.34L361.076 273.013L354.434 271.685L353.106 265.043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M353.106 265.043L351.778 271.685L345.136 273.013L351.778 274.34L353.106 280.982L354.434 274.34L361.076 273.013L354.434 271.685L353.106 265.043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_111_65811",
    x: 58.233,
    y: 207.662,
    width: 108.386,
    height: 108.386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_111_65811",
    x: 172.994,
    y: 260.261,
    width: 108.386,
    height: 108.386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_111_65811",
    x: 722.893,
    y: 116.81,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_111_65811",
    x: 829.685,
    y: 228.383,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_111_65811",
    x: 654.355,
    y: 292.14,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_111_65811",
    x: 287.756,
    y: 57.8351,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_111_65811",
    x: 351.512,
    y: 0.454445,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_111_65811",
    x: 494.964,
    y: 287.358,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_111_65811",
    x: 303.695,
    y: 287.358,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_111_65811",
    x: 176.182,
    y: 175.784,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_111_65811",
    x: 0.852272,
    y: 64.2107,
    width: 98.8223,
    height: 98.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_111_65811",
    x: 259.065,
    y: 19.5813,
    width: 92.4467,
    height: 92.4467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_111_65811",
    x: 561.908,
    y: 21.4593,
    width: 92.4467,
    height: 92.4467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_111_65811",
    x: 753.177,
    y: 175.784,
    width: 92.4467,
    height: 92.4467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_111_65811",
    x: 800.994,
    y: 16.3935,
    width: 92.4467,
    height: 92.4467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_111_65811",
    x: 593.786,
    y: 271.419,
    width: 92.4467,
    height: 92.4467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_111_65811",
    x: 290.944,
    y: 163.033,
    width: 92.4467,
    height: 92.4467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_111_65811",
    x: 306.883,
    y: 226.789,
    width: 92.4467,
    height: 92.4467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_65811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_65811",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSpinnerBg);
export default __webpack_public_path__ + "static/media/starSpinnerBG.268b0a469524b62a2a1af797eb648b86.svg";
export { ForwardRef as ReactComponent };